import TFoot from './TFoot';

export default TFoot;
